import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../store/language-context';
import img from "../../assets/used-icons/form-reg.png"
const FormInput = ({ label, type = 'text', name, value, onChange, required = true }) => {
    const { language } = useLanguage();
    
    return (
        <div className="mb-4">
            <label 
                htmlFor={name}
                className={`block text-gray-700 mb-2 ${language === 'ar' ? 'font-arabic' : ''}`}
            >
                {label}
            </label>
            <input
                type={type}
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                dir={language === 'ar' ? 'rtl' : 'ltr'}
            />
        </div>
    );
};

const RegistrationForm = ({ requiredFields = [], eventId }) => {
    const { t } = useTranslation();
    const { language } = useLanguage();
    
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        phone: '',
        company: '',
        job_title: '',
        country: '',
        city: ''
    });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`http://staging.ivorytraining.com/api/event/${eventId}/register`, {
                ...formData,
                event_id: eventId
            });
            if (response.status === 200) {
                alert(t('form.success'));
                setFormData({
                    username: '',
                    email: '',
                    phone: '',
                    company: '',
                    job_title: '',
                    country: '',
                    city: ''
                });
            }
        } catch (error) {
            console.error('Registration error:', error);
            alert(t('form.error'));
        }
    };
    
    return (
        <div className="py-16 bg-white">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    {/* Form Section */}
                    <div className="order-2 md:order-1">
                        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <FormInput
                                    label={t('form.username')}
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    required={requiredFields.includes('username')}
                                />
                                <FormInput
                                    label={t('form.email')}
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required={requiredFields.includes('email')}
                                />
                                <FormInput
                                    label={t('form.phone')}
                                    type="tel"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required={requiredFields.includes('phone')}
                                />
                                <FormInput
                                    label={t('form.company')}
                                    name="company"
                                    value={formData.company}
                                    onChange={handleChange}
                                    required={false}
                                />
                                <FormInput
                                    label={t('form.jobTitle')}
                                    name="job_title"
                                    value={formData.job_title}
                                    onChange={handleChange}
                                    required={false}
                                />
                                <FormInput
                                    label={t('form.country')}
                                    name="country"
                                    value={formData.country}
                                    onChange={handleChange}
                                    required={false}
                                />
                                <FormInput
                                    label={t('form.city')}
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required={false}
                                />
                            </div>
                            <button
                                type="submit"
                                className={`w-full mt-6 bg-[#6A2F38] text-white py-3 rounded-md hover:bg-primary/90 transition-colors ${language === 'ar' ? 'font-arabic' : ''}`}
                            >
                                {t('form.submit')}
                            </button>
                        </form>
                    </div>
                    
                    {/* Image Section */}
                    <div className="order-1 md:order-2">
                        <img
                            src={img}
                            alt={t('events.registration.imageAlt')}
                            className="w-full h-auto rounded-lg shadow-lg"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationForm;
